module.exports = __webpack_public_path__ + "img/class_arbreAVL-insertion.90ed8799.png";